export default {"src":"/_next/static/media/upload.03ab3aa2.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};